import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { NgxLoadingModule } from 'ngx-loading';
import {HttpClientModule} from "@angular/common/http";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CreateUserAccountComponent } from './create-user-account/create-user-account.component';
import { FleetDetailsComponent } from './fleet-details/fleet-details.component';
import {FormsModule} from "@angular/forms";
import { ReCaptchaModule } from 'angular2-recaptcha';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { ZipcodeEntryComponent } from './zipcode-entry/zipcode-entry.component';
import { CurrentConditionsComponent } from './current-conditions/current-conditions.component';
import { EffectsModule } from '@ngrx/effects';
import { CurrentConditionsEffects } from './effects/current-conditions.effects';
import {StoreRouterConnectingModule} from "@ngrx/router-store";
import {LoadTitlesEffects} from "./effects/load-titles.effects";
import { CreateUserFormComponent } from './create-user-account/create-user-form/create-user-form.component';
import {MatchingUsernamesDirective} from "./validators/matching-usernames.directive";
import {CheckValidUsernameDirective} from "./validators/check-valid-username.directive";
import { CreateFleetAndUserComponent } from './create-fleet-and-user/create-fleet-and-user.component';
import {FleetEffects} from "./effects/fleet.effects";
import {FleetAndUserEffects} from "./effects/fleet-and-user.effects";

@NgModule({
  declarations: [
    AppComponent,
    // CreateUserAccountComponent,
    // FleetDetailsComponent,
    // ZipcodeEntryComponent,
    // CurrentConditionsComponent,
    // CreateUserFormComponent,
    MatchingUsernamesDirective,
    CheckValidUsernameDirective,
    CreateFleetAndUserComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReCaptchaModule,
    NgxLoadingModule.forRoot({}),
    StoreModule.forRoot(reducers, { metaReducers }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forRoot([LoadTitlesEffects,FleetEffects, FleetAndUserEffects]),
    StoreRouterConnectingModule.forRoot({stateKey: 'router'})
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
